import { Grid } from '@mui/material';
import { getNodesAvailable } from 'lib/api/decisionEngine';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import { RevisionObjective } from 'pages/Settings/Components/Risk/Components/DecisionEngines/components/Create/types';
import { Node } from 'pages/Settings/Components/Risk/Components/DecisionEngines/components/Create/types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import NodesEditables from './Configuration';
import NewNodeDialog from './NewNodeDialog';
import TreeVisualization from './Visualization';

type Props = {
  revisionObjective: RevisionObjective;
  decisionNodesAssignation: Node[];
  setDecisionNodesAssignation: (nodes: Node[]) => void;
};

const TreeEngine = (props: Props) => {
  const {
    revisionObjective,
    decisionNodesAssignation,
    setDecisionNodesAssignation,
  } = props;
  const dispatch = useDispatch();
  const { isPending } = getNodesAvailable(dispatch, revisionObjective);
  const [openNodeEditables, setOpenNodeEditables] = useState(false);
  const [openAddNode, setOpenAddNode] = useState(false);
  const [counter, setCounter] = useState(
    decisionNodesAssignation.length ? decisionNodesAssignation.length + 1 : 1,
  );

  if (isPending) return <CenteredCircularProgress type="layout" />;

  return (
    <div>
      <HeaderWithActions
        title="Evaluaciones"
        type="pageHeader"
        buttons={[
          {
            action: () => setOpenNodeEditables(!openNodeEditables),
            name: !openNodeEditables ? 'Ver Lista' : 'Cerrar Lista',
            color: 'primary',
          },
        ]}
      />
      <Grid container style={{ paddingTop: '20px' }}>
        <Grid item xs={!openNodeEditables ? 12 : 8}>
          <TreeVisualization nodes={decisionNodesAssignation} />
        </Grid>
        {openNodeEditables && (
          <Grid item xs={4}>
            <NodesEditables
              decisionNodesAssignation={decisionNodesAssignation}
              setDecisionNodesAssignation={setDecisionNodesAssignation}
              setOpenAddNode={setOpenAddNode}
            />
          </Grid>
        )}
        {openAddNode && (
          <NewNodeDialog
            setCounter={setCounter}
            counter={counter}
            openAddNode={openAddNode}
            setOpenAddNode={setOpenAddNode}
            setDecisionNodesAssignation={setDecisionNodesAssignation}
            decisionNodesAssignation={decisionNodesAssignation}
            revisionObjective={revisionObjective}
          />
        )}
      </Grid>
    </div>
  );
};

export default TreeEngine;
